import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var range = function range(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var output = [];

  if (typeof end === 'undefined') {
    end = start;
    start = 0;
  }

  for (var i = start; i < end; i += step) {
    output.push(i);
  }

  return output;
};
var sampleOne = function sampleOne(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
};
var sample = function sample(arr) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var output = [];

  for (var i = 0; i < len; i++) {
    output.push(sampleOne(arr));
  }

  return output;
};
var random = function random(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
};
var generateId = function generateId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  // prettier-ignore
  var characters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  return sample(characters, len).join('');
};

var QUERY = '(prefers-reduced-motion: no-preference)';
var isRenderingOnServer = typeof window === 'undefined';

var getInitialState = function getInitialState() {
  // For our initial server render, we won't know if the user
  // prefers reduced motion, but it doesn't matter. This value
  // will be overwritten on the client, before any animations
  // occur.
  return isRenderingOnServer ? true : !window.matchMedia(QUERY).matches;
};

function usePrefersReducedMotion() {
  var _useState = useState(getInitialState),
      _useState2 = _slicedToArray(_useState, 2),
      prefersReducedMotion = _useState2[0],
      setPrefersReducedMotion = _useState2[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(QUERY);

    var listener = function listener(event) {
      setPrefersReducedMotion(!event.matches);
    };

    mediaQueryList.addListener(listener);
    return function () {
      mediaQueryList.removeListener(listener);
    };
  }, []);
  return prefersReducedMotion;
}

var useRandomInterval = function useRandomInterval(callback, minDelay, maxDelay) {
  var timeoutId = React.useRef(null);
  var savedCallback = React.useRef(callback);
  React.useEffect(function () {
    savedCallback.current = callback;
  });
  React.useEffect(function () {
    var isEnabled = typeof minDelay === 'number' && typeof maxDelay === 'number';

    if (isEnabled) {
      var handleTick = function handleTick() {
        var nextTickAt = random(minDelay, maxDelay);
        timeoutId.current = window.setTimeout(function () {
          savedCallback.current();
          handleTick();
        }, nextTickAt);
      };

      handleTick();
    }

    return function () {
      return window.clearTimeout(timeoutId.current);
    };
  }, [minDelay, maxDelay]);
  var cancel = React.useCallback(function () {
    window.clearTimeout(timeoutId.current);
  }, []);
  return cancel;
};

function useIsOnscreen(elementRef) {

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOnscreen = _React$useState2[0],
      setIsOnscreen = _React$useState2[1];

  React.useEffect(function () {
    if (!elementRef.current) {
      return null;
    }

    var observer = new window.IntersectionObserver(function (entries, observer) {
      var _entries = _slicedToArray(entries, 1),
          entry = _entries[0];

      setIsOnscreen(entry.intersectionRatio > 0);
    });
    observer.observe(elementRef.current);
    return function () {
      observer.disconnect();
    };
  }, [elementRef]);
  return isOnscreen;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  font-weight: bold;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n\n  @media (prefers-reduced-motion: no-preference) {\n    animation: ", " 1000ms linear;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n\n  @media (prefers-reduced-motion: no-preference) {\n    animation: ", " 900ms forwards;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  color: inherit;\n  text-shadow: 0px 0px 3px var(--color-background),\n    1px 1px 1px var(--color-background);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(100deg);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: translate3d(-50%, -50%, 0) scale(0);\n  }\n  50% {\n    transform: translate3d(-50%, -50%, 0) scale(1);\n  }\n  100% {\n    transform: translate3d(-50%, -50%, 0) scale(0);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n\n  &:focus {\n    outline: 2px auto var(--color-primary);\n    outline-offset: 2px;\n  }\n\n  &:focus:not(.focus-visible) {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var UnstyledButton = styled.button(_templateObject(), function (props) {
  return props.display || 'block';
});

var defaultGeneratePosition = function defaultGeneratePosition(size) {
  var style = {};
  style.left = random(0, 100) + '%';
  style.zIndex = sample([1, 3])[0];

  if (Math.random() > 0.5) {
    style.top = size * 0.5;
  } else {
    style.bottom = -size * 0.5;
  }

  return style;
};

var generateSparkle = function generateSparkle(color, minSize, maxSize, generatePosition) {
  var size = random(minSize, maxSize);
  return {
    id: generateId(),
    color: sample(color)[0],
    size: size,
    numOfPoints: 4,
    createdAt: Date.now(),
    style: generatePosition(size)
  };
};

var Sparkles = function Sparkles(_ref) {
  var _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? 250 : _ref$rate,
      _ref$variance = _ref.variance,
      variance = _ref$variance === void 0 ? 200 : _ref$variance,
      _ref$minSize = _ref.minSize,
      minSize = _ref$minSize === void 0 ? 10 : _ref$minSize,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? 20 : _ref$maxSize,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? ['#FFC700'] : _ref$colors,
      children = _ref.children,
      _ref$isToggleable = _ref.isToggleable,
      isToggleable = _ref$isToggleable === void 0 ? true : _ref$isToggleable,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$generatePosition = _ref.generatePosition,
      generatePosition = _ref$generatePosition === void 0 ? defaultGeneratePosition : _ref$generatePosition,
      delegated = _objectWithoutProperties(_ref, ["rate", "variance", "minSize", "maxSize", "colors", "children", "isToggleable", "style", "generatePosition"]);

  var color = colors === "rainbow" ? ["hsl(50deg, 100%, 65%)", "hsl(210deg, 100%, 65%)", "hsl(340deg, 100%, 60%)"] : colors;

  var _React$useState = React.useState(function () {
    return range(3).map(function () {
      return generateSparkle(color, minSize, maxSize, generatePosition);
    });
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sparkles = _React$useState2[0],
      setSparkles = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isEnabled = _React$useState4[0],
      setIsEnabled = _React$useState4[1];

  var ref = React.useRef();
  var isOnscreen = useIsOnscreen(ref);
  var prefersReducedMotion = usePrefersReducedMotion();
  useRandomInterval(function () {
    if (!isOnscreen || !isEnabled) {
      return;
    }

    var sparkle = generateSparkle(color, minSize, maxSize, generatePosition);
    var now = Date.now();
    var nextSparkles = sparkles.filter(function (sp) {
      var delta = now - sp.createdAt;
      return delta < 1000;
    });
    nextSparkles.push(sparkle);
    setSparkles(nextSparkles);
  }, prefersReducedMotion ? null : rate - variance, prefersReducedMotion ? null : rate + variance);
  return React.createElement(Wrapper, _extends({
    ref: ref,
    asElement: isToggleable ? UnstyledButton : 'div',
    onClick: function onClick() {
      if (!isToggleable) {
        return;
      }

      setIsEnabled(!isEnabled);
    },
    style: _objectSpread2({}, style, {
      cursor: isToggleable && !prefersReducedMotion ? 'pointer' : 'default'
    })
  }, delegated), sparkles.map(function (sparkle) {
    return React.createElement(Sparkle, {
      key: sparkle.id,
      color: sparkle.color,
      size: sparkle.size,
      numOfPoints: sparkle.numOfPoints,
      style: sparkle.style
    });
  }), React.createElement(ChildWrapper, null, children));
};

var Sparkle = function Sparkle(_ref2) {
  var size = _ref2.size,
      color = _ref2.color,
      style = _ref2.style,
      _ref2$numOfPoints = _ref2.numOfPoints,
      numOfPoints = _ref2$numOfPoints === void 0 ? 4 : _ref2$numOfPoints;
  var path = numOfPoints === 4 ? 'M92 0C92 0 96 63.4731 108.263 75.7365C120.527 88 184 92 184 92C184 92 118.527 98 108.263 108.263C98 118.527 92 184 92 184C92 184 86.4731 119 75.7365 108.263C65 97.5269 0 92 0 92C0 92 63.9731 87.5 75.7365 75.7365C87.5 63.9731 92 0 92 0Z' : 'M34 0C34 0 33.4886 20.0074 41.7749 26.3376C50.0612 32.6678 68 25.9737 68 25.9737C68 25.9737 49.7451 31.6449 46.58 41.8873C43.4149 52.1298 55.0132 68 55.0132 68C55.0132 68 44.2424 51.4976 34 51.4976C23.7576 51.4976 12.9868 68 12.9868 68C12.9868 68 24.5851 52.1298 21.42 41.8873C18.2549 31.6449 0 25.9737 0 25.9737C0 25.9737 17.9388 32.6678 26.2251 26.3376C34.5114 20.0074 34 0 34 0Z';
  return React.createElement(SparkleWrapper, {
    style: style
  }, React.createElement(SparkleSvg, {
    width: size,
    height: size,
    viewBox: "0 0 184 184",
    fill: "none"
  }, React.createElement("path", {
    d: path,
    fill: color
  })));
};

var comeInOut = keyframes(_templateObject2());
var spin = keyframes(_templateObject3());
var Wrapper = styled(UnstyledButton)(_templateObject4());
var SparkleWrapper = styled.span(_templateObject5(), comeInOut);
var SparkleSvg = styled.svg(_templateObject6(), spin);
var ChildWrapper = styled.strong(_templateObject7());

export default Sparkles;
